<template>
  <div class="element-upload">
    <Row>
      <Col>
        <Upload ref="upload"
                :name="name"
                :action="baseURL+url"
                :format="format"
                :headers="headers"
                :data="data"
                :show-upload-list="false"
                :before-upload="handleBeforeUpload"
                :on-format-error="handleFormatError"
                :on-success="handleSuccess"
        >
          <Input :value="file?file.name:''" placeholder="请选择文件" readonly style="width: 200px;"></Input>
          <div class="tip" slot="tip" v-html="comment" v-show="comment"></div>
          <Button type="primary" class="element-upload">浏览</Button>
          <Button type="primary" @click.native="upload" :loading="loadingStatus" :disabled="!file">{{ loadingStatus ? '上传中' : '上传' }}</Button>
        </Upload>
      </Col>
    </Row>
  </div>
</template>

<script>
export default {
  name: 'elementUpload',
  props: {
    name: {
      default: 'file'
    },
    url: '',
    format: {
      default: []
    },
    comment: '',
    data: {}
  },
  data () {
    return {
      baseURL: '/dup',
      headers: {},
      file: null,
      loadingStatus: false
    }
  },
  created () {
    this.headers.token = this.$store.state.user.token;
  },
  methods: {
    handleFormatError (file) {
      this.$Message.warning({
        content: file.name + '文件类型不符合要求，请选择' + this.format.join('、') + '文件',
        duration: 5
      });
    },
    handleBeforeUpload (file) {
      this.file = file;
      return false;
    },
    upload (event) {
      event.stopPropagation();
      this.loadingStatus = true;
      this.$refs['upload'].post(this.file);
    },
    handleSuccess (response) {
      if (response.code === 200) {
        this.$Message.success({
          content: this.file.name + '上传成功',
          duration: 5
        });
        this.file = null;
        this.loadingStatus = false;
        this.$emit('on-success');
      } else {
        this.$store.commit('showErrorMsg', {errMsg: response.msg, url: response.data});
        this.loadingStatus = false;
      }
    }
  }
}
</script>

<style lang="less">
  .element-upload {
    .kh-upload {
      display: inline-block;
      .tip {
        line-height: 18px;
        margin-top: 50px;
        color: @text-color;
        opacity: 0.9;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/elements/upload.vue